import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Modal, ModalHeader } from '@unbridaled/ui-components'
import { DiamondsTable } from 'lib/components/diamondsTable'
import { DASOrderSuccessfullModalProps, DASOrderSuccessfullModalContentProps } from 'types/interfaces';
import {
  ResponsiveModal,
  ResponsiveModalContent,
  ResponsiveModalFooterDesktop,
  ResponsiveModalHeaderDesktop,
  ResponsiveModalHeaderMobile
} from '../ResponsiveModal/ResponsiveModal'
import { ResponsiveModalProps } from '@unbridaled/ui-components/ResponsiveModal'

export const ModalContent: React.FC<DASOrderSuccessfullModalContentProps> = ({
  gems,
  config
}) => {
  return (
    <div id="ub-print-section" className="unbridaled-confirmation-content-wrapper">
      <div className="unbridaled-diamond-data diamond-data">
        <DiamondsTable
          selectedDiamonds={gems}
          sourceTypes={config.sourceTypes}
        />
      </div>
    </div>
  )
};

export type ModalProps = DASOrderSuccessfullModalProps & ResponsiveModalProps

export const DASOrderSuccessfullModal = ({
  open,
  gems,
  orderType,
  config,
  onClose,
  ...props
}: ModalProps): React.ReactNode => {
  const { t } = useTranslation()
  const orderTypeName = orderType === 'm' ? t('common.memo') : t('common.invoice')
  const handleClose = (): void => {
    onClose()
  }
  return (
    <ResponsiveModal size="uui-w-[70%] uui-max-w-2xl" {...props} onClose={handleClose} open={open}>
      <ResponsiveModalHeaderDesktop
        title={t('dasOrderSuccessModal.header', { orderTypeName })}
        onClose={handleClose}
      />
      <ResponsiveModalHeaderMobile
        title={t('dasOrderSuccessModal.header', { orderTypeName })}
        trailingIcon={
          <Button className="uui-flex-1 mobile-modal-button uui-justify-end unbridaled-cancel" onClick={handleClose}>
            {t('common.confirm', 'Confirm')}
          </Button>
        }
        leadingIcon={
          <Button
            className="uui-flex-1 mobile-modal-button uui-justify-start unbridaled-submit"
            onClick={(): void => window.print()}
          >
            {t('common.print')}
          </Button>
        }
      />
      <ResponsiveModalContent>
        <ModalContent gems={gems} config={config} />
      </ResponsiveModalContent>
      <ResponsiveModalFooterDesktop>
        <div className="uui-gap-4 uui-flex">
          <Button className="uui-flex-1 unbridaled-submit" onClick={(): void => window.print()}>
            {t('common.print')}
          </Button>
          <Button className="unbridaled-confirm uui-flex-1 unbridaled-cancel" onClick={handleClose}>
            {t('common.confirm', 'Confirm')}
          </Button>
        </div>
      </ResponsiveModalFooterDesktop>
    </ResponsiveModal>
  )
}